export default __webpack_public_path__ + "static/media/1967.43367ed0.png";